import React, { forwardRef } from "react";
import "./styles.css";

export default forwardRef(({ children, heading }, ref) => {
    return (
        <div className={window.location.href.includes("interviewSessions") ? "" : "containerDrop"} ref={ref}>
            {heading}
            <div className="dropBody">{children}</div>
        </div>
    );
});
